import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { FieldType, IFieldValue, InputField } from "veronica-ui-component/dist/component/core";

export const SpecialIndForwarderRefAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "150px" }}>
                    <NbisCommonField
                        errorMessages={{}}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={chargeBatchUpdate.specialInd ?? ""}
                        fieldValue={chargeBatchUpdate.specialInd}
                        fieldLabel={"Special Ind"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'specialInd'}
                        maxLength={60}
                        options={chargeDetailState.dynamicOptions.specialIndDropdownOptions}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>
                <div className='im-flex-row-item'>
                    <InputField
                        label='Forwarder Reference.'
                        width='150px'
                        type="text"
                        value={chargeBatchUpdate.forwarderReference || ''}
                        onChange={(e: any) => chargeDetailVM.onInputTextChange(e, 'forwarderReference', chargeBatchUpdate, 'chargeBatchUpdate')}
                        allowedSpecialChars={'all'} />
                </div>

            </div>
        </>
    )
}